import { AnalyticsPage } from "@/pages/dashboard/analytics/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/dashboard/analytics")({
    component: AnalyticsPage,
});
